<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
    class="px-3 pt-0"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <base-material-card
          color="primary"
          icon="mdi-view-dashboard"
          :title="$t('dashboard')"
          :app-online="appOnline"
          class="py-3 px-5"
        >
          <p class="text-center">
            Seja bem-vindo,
          </p>
          <div
            class="transition-swing font-weight-light text-center text-h3"
            v-text="nomeUsuario"
          />
          <v-divider class="mb-5" />

          <div v-if="loading">
            <v-skeleton-loader
              v-for="i in 2"
              :key="i"
              height="250"
              type="card"
            />
          </div>

          <div v-else>
            <div
              v-for="(video, index) in videos"
              :key="index"
              class="mb-10"
            >
              <div class="text-center grey--text text-h4 font-weight-light mb-3">
                {{ video.titulo }}
              </div>
              <div class="text-center red--text text-h4 font-weight-bold">
                {{ video.descricao }}
              </div>
              <youtube-embed :video-id="video.videoId" />
            </div>
          </div>
        </base-material-card>
      </v-col>

      <v-col
        v-if="false"
        cols="12"
        lg="12"
        class="px-1"
      >
        <dashboard-graficos-form />
      </v-col>
    </v-row>

    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import UsuarioProdutor from '../../services/usuarioprodutor'
  import YoutubeEmbed from '../../components/base/YoutubeEmbed'
  import utils from '../../services/utils'
  import { mapState } from 'vuex'
  import VideosService from '../../services/videosservice'

  export default {
    name: 'DashboardDashboard',
    components: {
      YoutubeEmbed,
      DashboardCoreSnackbar: () => import('./components/core/Snackbar'),
      DashboardGraficosForm: () => import('./forms/GraficosForm'),
    },
    mixins: [utils],

    data: vm => ({
      appOnline: navigator.onLine,
      nomeUsuario: 'Usuário Produtor',
      snackbar: {
        visible: false,
        color: 'success',
        message: '',
        timeout: 3000,
      },
      loading: false,
      videos: [],
    }),

    computed: {
      ...mapState(['versao']),
    },

    mounted () {
      if (localStorage.nome !== '') {
        this.nomeUsuario = localStorage.nome
      }

      if (localStorage.chaveativacao) {
        this.loading = true
        UsuarioProdutor.verificaAcessoUsuario(localStorage.chaveativacao).then(resposta => {
          if (resposta.data.status !== 'ativo') {
            this.limpaDadosOffline()
            this.$router.push('/registrar')
          }

          this.verificaVersao(resposta.data.versao_vue)
          localStorage.setItem('usuarioIdentificado', resposta.data.usuario_identificado)

          if (localStorage.token && localStorage.token !== resposta.data.token) {
            UsuarioProdutor.atualizaToken(localStorage.chaveativacao, localStorage.token)
              .then(result => { if (result.data.success) console.log(result.data.msg) })
              .catch(e => console.log('Erro ao atualizar token:', e))
          }

          if (localStorage.enviaNotif && localStorage.enviaNotif !== resposta.data.enviaNotif) {
            UsuarioProdutor.enviaMensagem(localStorage.chaveativacao, localStorage.enviaNotif)
              .then(result => { if (result.data.success) console.log(result.data.msg) })
              .catch(e => console.log('Erro ao atualizar configurações de notificação:', e))
          }

          VideosService.listarVideos().then(res => {
            if (res.data.success_request && Array.isArray(res.data.videos)) {
              this.videos = res.data.videos.map(v => ({
                ...v,
                videoId: this.extrairVideoId(v.url),
              }))
            }
          }).catch(err => console.log('Erro ao buscar vídeos:', err))

          this.loading = false
          this.appOnline = true
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
            this.appOnline = false
          } else if (e.data && e.data.errors[0] === 'Usuário não encontrado') {
            console.log('Erro ao verificar acesso(): ' + e.data.errors[0])
            this.limpaDadosOffline()
            this.$router.push('/registrar')
          } else {
            console.log('Erro verifica acesso(): ' + e)
          }
        })
      } else {
        this.limpaDadosOffline()
        this.$router.push('/registrar')
      }
    },

    methods: {
      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      limpaDadosOffline () {
        // localStorage.removeItem('codigoativacaotemp')
        // localStorage.removeItem('chaveativacao')
        localStorage.removeItem('countDownViewMenu')
        // localStorage.clear()
      },

      extrairVideoId (url) {
        const regex = /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([A-Za-z0-9_-]{11})/
        const match = url.match(regex)
        return match ? match[1] : null
      },
    },
  }
</script>
